module.exports={
    btn:{
        tips_reelect_btn:"Nyt billede",
        cancel_btn:"Afbestille",
        tips_continue_dispose:"Opskalere understøttede billeder",
        tips_return:"Nyt billede",
        tips_upgrade:"Opgrader",
        tips_yes:"OKAY",
        delete:"Slet",
        download:"Hent",
        upload_image:"Upload billede",
        new_image:"Nyt billede",
        save_all:"Gem alle",
        cancel:"Annullerer",
        save:"Gemme",
        view_comparison:"Se sammenligning",
        hide_comparison:"Skjul sammenligning",
        previous:"Tidligere",
        next:"Næste",
        continue_download:"Gem billeder med vandmærker",
        present:"Anvend på dette billede",
        all_wait:"Anvend på Billeder i Vent",
        all:"Anvend på alle billeder",
        history:"Historie",
        login:"Log på",
    },
    tips:{
        please_upgrade:"Din nuværende plan understøtter ikke upload eller opskalering af billeder i batches. Opgrader det for at få flere fordele.",
        errorlistinfo:"XXX billeder er valgt. XXX billeder understøttes, men XXX billeder understøttes ikke. Følgende er ikke-understøttede billeder:",
        max:"Overskrid den maksimale billedstørrelsesgrænse på 10 MB!",
        max_size:"Overskrid den maksimale billedsidelængdegrænse på 4096px!",
        continue_dispose:"Opskalere understøttede billeder",
        please_multiple:"Vælg venligst forstørrelsen",
        max_multiple:"* Dit billede vil højst blive forstørret til 4K (den længste side vil ikke overstige 4096px).",
        title:"Navn",
        reasons:"Grunde",
        upload_type:"Ikke understøttet",
        used_up:"Antallet af gemte HD-billeder uden vandmærker er brugt op. Opgrader venligst din konto. Eller du kan gemme HD-billeder med vandmærker.",
        edit_multiple:"Der er uploadet flere billeder. Vælg venligst billeder, som du vil ændre forstørrelsen. Efter valg vil disse billeder blive opskaleret igen til den nye forstørrelse.",
        download_confirm:"Nogle billeder behandles stadig. Er du sikker på at gemme alle opskalerede billeder? Når du gemmer det samme billede gentagne gange, vil dit antal gemte billeder ikke blive trukket fra igen.有图片未完成，确定保存当前所有已完成的图片吗？重复保存不会重复扣除次数。",
        waiting_save:"Nogle billeder behandles stadig. Gem venligst senere.",
        
    },
    header:{
        title:"Aiseesoft Image Upscaler Online",
        hd:" HD-billede(r)",
        watermarks:"uden vandmærker kan downloades i øjeblikket.",
        view_details:"Se detaljer",
        loading:"Indlæser…",
    },
    content:{
        failed:"Mislykkedes",
        completed:"Fuldført",
        processing:"Forarbejdning",
        img_processing:"Forarbejdning…",
        img_failed:"Kunne ikke behandle",
        uploading:"Uploader",
        img_uploading:"Uploader...",
        wait_upoading:"Venter på at uploade...",
        waiting:"Venter",
        img_waiting:"Venter…",
        empty:"Tom",
        magnification:"Forstørrelse:",
        drop:"Eller slip din billedfil her for at opskalere og forbedre!",
        original:"Original:",
        output:"Produktion:",
        img_rendering1:"Dit billede er blevet opskaleret.",
        img_rendering2:"Vi arbejder på at gengive billedet i høj kvalitet til forhåndsvisning. Vent venligst...",
        no_watermark:"Efter lagring har billedet intet vandmærke.",
    },
    banner_msg:"Vælg en plan for billedopskalering",
    monthly:"MÅNEDLIGE",
    lifetime:"LIVSTID",
    choose_plan:"Vælg din plan baseret på antallet af billeder",
    return_home:"Tillykke! Du har opgraderet med succes. Venligst vend tilbage til startsiden og brug dette produkt.",
    congratulations:"Tillykke! Du har opgraderet med succes. Fordelene er bundet til den e-mailadresse, du efterlod under opgraderingen. Brug venligst den konto, der er registreret eller knyttet til e-mailadressen til",
    login_benefits:"log ind for at bruge fordele",
    no_registered:". Hvis du ikke har registreret eller knyttet en konto til e-mailadressen, bedes du",
    register_account:"bruge e-mailadressen til at registrere en konto",
    other_accounts:" eller link andre konti til denne e-mailadresse for at bruge fordele.",
    btn_close:"Tæt",
    free:"Gratis",
    btn_get_started:"Kom igang",
    // access_to:"Adgang ti",
    upscale_images:"Opskalere billeder",
    up_to:"Op til ",
    per_image:" pr billede",
    resolution_of:"Op til opløsning af",
    default_level:"Opskalere billeder på standardniveau",
    image_downloads:"2 HD-billede downloads uden vandmærke",
    unlimited_image:"Ubegrænsede billeddownloads med vandmærke",
    SHA256_encryption:"SHA256 krypteringsteknik",
    mon:"Månedlige",
    images:"billeder",
    high_resolution:" med høj opløsning kvalitet",
    tax_incl:"Inkl. skat.",
    image:"billede",
    secure_checkout:"Sikker checkout",
    everything:"Alt er gratis, og",
    upscaling_levels:"Alle opskaleringsniveauer kan vælges",
    unlimited_image_without:"Ubegrænsede billeddownloads uden vandmærke",
    viewable_editing:"Den synlige redigeringshistorik er gyldig for",
    days:" dage",
    high_level:"Højt niveau",
    priority_processing:" prioriteret behandling",
    left:"Livstid",
    resolution:" løsning",


    
    "history_will":"Udløber efter",
    "history.days":"Dage)",
    "history.hours":"timer",
    "expired":"Udløbet",
    "access_to":"Med den gratis prøveperiode kan du kun",
    "pricing.upload_images":"Upload billeder",
    "pricing.under":"under",
    "pricing.images":"billeder",
    "pricing.without_watermark":"uden vandmærke",
    "pricing.process_images":"Behandle billeder op til",
    "pricing.pixels":"pixels",
    "pricing.enjoy_limited":"Nyd begrænsede eksklusive karakterer",
    "pricing.download":"Hent",
    "pricing.HD_images":"HD-billeder uden vandmærke",
    "pricing.and_you":"Og du kan lide af",
    "pricing.slow_upscaling":"langsom opskalering",
    "pricing.lower_priority":"lavere prioritet",
    "pricing.without":"uden vandmærke",
    "pricing.tax":"Moms er inkluderet i salgsprisen og vil blive beregnet automatisk baseret på dit land og din region. I indkøbskurven kan du se det detaljerede afgiftsbeløb. Dit endelige betalingsbeløb skal være det samme som den viste pris.",
    "pricing.you_can":"Med abonnement kan du",
    "pricing.up_to":"Upload billeder op til",
    "pricing.upscale_images":"Fornemme billeder med",
    "pricing.no_watermark":"intet vandmærke",
    "pricing.enhance":"Forbedre",
    "pricing.or_more":"billeder eller mere",
    "pricing.in_batch":"i batch",
    "pricing.enlarge_images":"Forstør billeder ind",
    "pricing.and":"og",
    "pricing.times_with":"gange uden grænser",
    "pricing.enjoy":"god fornøjelse",
    "pricing.of_history":"af historiens lagringstid",
    "pricing.experience":"Erfaring",
    "pricing.fast_upscaling":"hurtig opskalering",
    "pricing.higher_priority":"højere prioritet",
    "pricing.early_access":"Tidlig adgang til nye funktioner",
    "pricing.cancel_anytime":"Annuller når som helst",
    "pricing.lifetime_license":"Med livstidslicens kan du",
    "pricing.and_there":"Og der vil være",
    "pricing.no_expiration":"ingen udløbsdato",
    "pricing.unless":"medmindre du løber tør for alle opskalere",

    "buynow.pop.credit":"kredit",
    "buynow.pop.credits":"kreditter",

    "isUnderequityTip_msg1":"Du har valgt {%} billeder til batchbehandling, og der er ikke nok resterende fordele. Du har stadig brug for {%} kreditter (i øjeblikket er der {%} kreditter tilbage). Hvis du skal behandle, skal du købe fordele for at fortsætte bearbejde billederne.",
    "isUnderequityTip_msg2":"Du har valgt {%} billeder til batchbehandling, og der er ikke nok resterende fordele. Du har stadig brug for {%} kreditter (i øjeblikket er der {%} billeder af fordele tilbage). Hvis du skal behandle, bedes du købe fordele for at fortsætte med at behandle billederne.",
    "isUnderequityTip_msg3":"Du har valgt {%} billeder til batchbehandling, og der er ikke nok resterende fordele. Du har stadig brug for {%} kreditter (i øjeblikket er der {%} kreditter, {%} billeder af fordele tilbage), hvis du skal proces, køb venligst fordele for at fortsætte med at behandle billederne.",
    "btn_buy_now":"Køb nu",
    "isEquityDepletionTip_msg":"Dine nuværende fordele er brugt op. Køb venligst fordelene til batchbehandling.",

    "pricing.h1":"Aiseesoft AI Photo Editor - Planer og priser",
    "pricing.banner_content":"Få AI Photo Editor's kreditter til at fjerne billedbaggrunde, opskalere billeder og fjerne objekter fra billeder online eller fra desktop.",
    "pricing.best_seller":"Bedst sælgende",
    "pricing.monthly":"Månedligt abonnement",
    "pricing.credits":"kreditter",
    "pricing.lifetime":"Livstid",
    "pricing.note":"Bemærk",
    "pricing.buy_now":"Køb nu",
    "pricing.note_content":"Købte kreditter er knyttet til den e-mailadresse, du indtastede i indkøbskurven. For at bruge disse kreditter skal du registrere dig eller logge ind med den samme e-mailadresse.",

    "header.buy_more":"Køb mere",
    "header.available_credits":"Tilgængelige kreditter",
    "header.credits":"kredit(ter)"
}